import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Alert,
    CardBody,
    Button,
    Label,
    Input,
    FormFeedback,
    Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { getCountry, getStateByCountryId } from "../../api/countryService";
import { UserProfileData, updateProfile } from "../../api/userProfileService";
import withRouter from "../../components/Common/withRouter";
import userprofile from "../../assets/images/users/userprofile.jpg";
import { editProfile, resetProfileFlag } from "../../store/actions";
import { createSelector } from "reselect";
import "../../assets/css/userprofile.css";
import regBg from '../../assets/images/login_reg/login_bg3.jpg';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import Select from "react-select";
import { Link } from "react-router-dom";

const UserProfile = () => {
    document.title = "Profile";

    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [idx, setIdx] = useState(1);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [customerId, setCustomerId] = useState("");

    const handleChange = (event) => {
        setCountries(event.target.value);
    };

    const userprofilepage = createSelector(
        (state) => state.profile,
        (state) => ({
            error: state.error,
            success: state.success,
        })
    );

    const { error, success } = useSelector(userprofilepage);
    const isGlobalSubmitting = useRef(false);

    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            const obj = JSON.parse(localStorage.getItem("authUser"));
            setName(obj.username);
            setEmail(obj.email);
            setIdx(obj.uid || 1);
            setTimeout(() => dispatch(resetProfileFlag()), 3000);
        }
    }, [dispatch, success]);

    // Formik setup (based on Register fields)
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            firstName: "",
            lastName: "",
            companyName: "",
            username: name || "",
            password: "",
            confirmPassword: "",
            email: email || "",
            phone: "",
            businessType: "",
            address: "",
            country: "",
            state: "",
            city: "",
            zipCode: "",
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("Please enter your First Name"),
            lastName: Yup.string().required("Please enter your Last Name"),
            companyName: Yup.string().required("Please enter your Company Name"),
            email: Yup.string().email("Invalid email format").required("Please enter your Email"),
            phone: Yup.string().required("Please enter your Phone Number"),
            businessType: Yup.string().required("Please select your Business Type"),
            address: Yup.string().required("Please enter your Address"),
            country: Yup.string().required("Please select your Country"),
            state: Yup.string().required("Please select your State"),
            city: Yup.string().required("Please enter your City"),
            zipCode: Yup.string().required("Please enter your Zip Code"),
        }),

        onSubmit: async (values, { setSubmitting }) => {
            console.log("Form submitted with values:", values);

            try {
                const user = JSON.parse(localStorage.getItem("authUser"));
                const payload = {
                    Customer_ID: String(customerId || ""),
                    FirstName: values.firstName,
                    LastName: values.lastName,
                    CompanyName: values.companyName,
                    Country_ID: values.country?.toString(),
                    State_ID: values.state?.toString(),
                    City: values.city,
                    Address: values.address,
                    MobileNo: values.phone,
                    PhoneNo: "",
                    Email: values.email,
                    BusinessType: values.businessType,
                    ZipCode: values.zipCode,
                };

                console.log("Update Profile Payload:", payload);
                const response = await updateProfile(payload);
                console.log("Update Profile API Response:", response);

                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    toast.success(response.Message[0].RETURNMESSAGE || "Profile updated successfully!");
                } else {
                    toast.error(response?.Message?.[0]?.RETURNMESSAGE || "Failed to update profile");
                }
            } catch (error) {
                console.error("Update Profile API Error:", error);
                toast.error("Something went wrong while updating profile.");
            } finally {
                setSubmitting(false);
            }
        },
    });


    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await getCountry(); // Assuming this returns a list of countries
                //console.log('country response', response)
                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    setCountries(response || []);
                }
                else {
                    toast.error(response?.Message?.[0]?.RETURNMESSAGE || "Country Not fetched");
                }
            } catch (error) {
                toast.error("Error fetching countries:", error);
            }
        };

        fetchCountries();
    }, []);


    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                setLoading(true);

                const response = await UserProfileData();
                //console.log("UserProfileData Response:", response);
                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    if (response?.UserDetail?.[0]) {
                        const profile = response.UserDetail[0];

                        //Store Customer ID for update API
                        setCustomerId(profile.CUSTOMER_ID || ""); //store it in state

                        //Set form fields
                        validation.setValues({
                            firstName: profile.FIRSTNAME || "",
                            lastName: profile.LASTNAME || "",
                            companyName: profile.COMPANYNAME || "",
                            username: profile.USERNAME || "",
                            email: profile.EMAIL || "",
                            phone: profile.MOBILENO || "",
                            businessType: profile.BUSINESSTYPE || "",
                            address: profile.ADDRESS || "",
                            country: profile.COUNTRY_ID || "",
                            state: profile.STATE_ID || "",
                            city: profile.CITY || "",
                            zipCode: profile.ZIPCODE || "",
                            password: "",
                            confirmPassword: "",
                            customerId: profile.CUSTOMER_ID ? String(profile.CUSTOMER_ID) : "", //ensure string

                        });

                        if (profile.COUNTRY_ID) {
                            try {
                                const stateResponse = await getStateByCountryId({
                                    IntCountyID: profile.COUNTRY_ID,
                                });
                                if (response?.Message?.[0]?.RETURNCODE === "1") {
                                    if (stateResponse?.States) {
                                        setStates(stateResponse.States);
                                    } else {
                                        console.warn(" No states found for this country.");
                                    }
                                }
                                else {
                                    toast.error(response?.Message?.[0]?.RETURNMESSAGE || "Failed to load states ");
                                }
                            } catch (stateErr) {
                                console.error("Error fetching states:", stateErr);
                                toast.error("Failed to load states");
                            }
                        }
                    } else {
                        toast.info("No profile details found for this user");
                    }
                }
                else {
                    toast.error(response?.Message?.[0]?.RETURNMESSAGE || "profile detail not fetched properly");
                }
            } catch (error) {
                console.error("Error fetching user profile:", error);
                toast.error("Failed to load profile details");
            } finally {
                setLoading(false);
            }
        };

        fetchUserProfile();
    }, []);

    return (

        <div
            className="bg-pattern d-flex flex-column"
            style={{ backgroundImage: `url(${regBg})` }}
        >
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                draggable
                theme="colored"
            />

            <div className="account-pages flex-grow-1 pb-5 main-background">


                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8} xl={6}>
                            <Card className="mt-5">
                                <CardBody className="p-4 register-background" >
                                    {/* {/* <div className="text-center mb-3">
                    <h4 className="fw-bold mb-1 profile-heading">My Profile</h4>
                  </div> */}

                                    <div className="text-center mb-3">
                                        <h4 className="fw-bold mb-1 profile-heading">Your Profile </h4>
                                    </div>



                                    <div className="text-center mb-3">
                                        <img
                                            src={userprofile}
                                            alt="user profile"
                                            className="avatar-lg rounded-circle mb-3 border border-3 border-white shadow"
                                        />
                                        <h4 className="fw-bold mb-1">{name}</h4>
                                        <p className="text-muted mb-0">{email}</p>
                                    </div>

                                    {error && <Alert color="danger">{error}</Alert>}
                                    {success && <Alert color="success">{success}</Alert>}

                                    <Form
                                        className="form-horizontal"
                                        onSubmit={validation.handleSubmit}
                                    >
                                        {/* First & Last Name */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="firstName">First Name</Label>
                                                    <Input
                                                        id="firstName"
                                                        name="firstName"
                                                        type="text"
                                                        placeholder="Enter First Name"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.firstName}
                                                        invalid={validation.touched.firstName && !!validation.errors.firstName}
                                                    />
                                                    <FormFeedback>{validation.errors.firstName}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="lastName">Last Name</Label>
                                                    <Input
                                                        id="lastName"
                                                        name="lastName"
                                                        type="text"
                                                        placeholder="Enter Last Name"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.lastName}
                                                        invalid={validation.touched.lastName && !!validation.errors.lastName}
                                                    />
                                                    <FormFeedback>{validation.errors.lastName}</FormFeedback>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="companyName">Company Name</Label>
                                                    <Input
                                                        id="companyName"
                                                        name="companyName"
                                                        type="text"
                                                        placeholder="Enter Company Name"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.companyName}
                                                        invalid={validation.touched.companyName && !!validation.errors.companyName}
                                                    />
                                                    <FormFeedback>{validation.errors.companyName}</FormFeedback>
                                                </div>
                                            </Col>


                                        </Row>

                                        {/* Username */}
                                        <Row>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="username">Username</Label>
                                                    <Input
                                                        id="username"
                                                        name="username"
                                                        type="text"
                                                        placeholder="Enter Username"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.username}
                                                        invalid={validation.touched.username && !!validation.errors.username}
                                                    />
                                                    <FormFeedback>{validation.errors.username}</FormFeedback>
                                                </div>
                                            </Col>


                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="email">Email</Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        type="email"
                                                        placeholder="Enter Email"
                                                        value={validation.values.email}
                                                        disabled
                                                    />
                                                    <FormFeedback>{validation.errors.email}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Phone */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="phone">Mobile Number</Label>
                                                    <Input
                                                        id="phone"
                                                        name="phone"
                                                        type="number"
                                                        placeholder="Enter Phone Number"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone}
                                                        invalid={validation.touched.phone && !!validation.errors.phone}
                                                    />
                                                    <FormFeedback>{validation.errors.phone}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="businessType">Business Type</Label>
                                                    <Input
                                                        id="businessType"
                                                        name="businessType"
                                                        type="select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.businessType}
                                                        invalid={validation.touched.businessType && !!validation.errors.businessType}
                                                    >
                                                        <option value="">Select Business Type</option>
                                                        <option value="Wholesaler">Wholesaler</option>
                                                        <option value="Retailer">Retailer</option>
                                                        <option value="Others">Others</option>
                                                    </Input>
                                                    <FormFeedback>{validation.errors.businessType}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Address */}
                                        <div className="mb-2">
                                            <Label className="form-label-login" htmlFor="address">Address</Label>
                                            <Input
                                                id="address"
                                                name="address"
                                                type="textarea"
                                                placeholder="Enter Address"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.address}
                                                invalid={validation.touched.address && !!validation.errors.address}
                                            />
                                            {/* <FormFeedback>{validation.errors.address}</FormFeedback> */}
                                        </div>

                                        {/* Country / State */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="country">Country</Label>
                                                    <Select
                                                        inputId="country"
                                                        name="country"
                                                        options={Array.isArray(countries?.Countries)
                                                            ? countries.Countries.map(country => ({
                                                                value: country.COUNTRY_ID,
                                                                label: country.COUNTRYNAME
                                                            }))
                                                            : []}
                                                        isSearchable
                                                        isClearable
                                                        placeholder="Select Country"
                                                        value={
                                                            countries?.Countries?.find(r => r.COUNTRY_ID === validation.values.country)
                                                                ? {
                                                                    value: validation.values.country,
                                                                    label: countries.Countries.find(r => r.COUNTRY_ID === validation.values.country).COUNTRYNAME
                                                                }
                                                                : null
                                                        }
                                                        onChange={async (selectedOption) => {
                                                            const selectedCountryId = selectedOption ? selectedOption.value : "";
                                                            validation.setFieldValue("country", selectedOption ? selectedOption.value : "");
                                                            validation.setFieldValue("state", ""); // reset state field when country changes
                                                            if (selectedCountryId) {
                                                                try {
                                                                    const response = await getStateByCountryId({ IntCountyID: selectedCountryId });
                                                                    if (response?.States) {
                                                                        setStates(response.States);
                                                                    } else {
                                                                        setStates([]);
                                                                    }
                                                                } catch (error) {
                                                                    console.error("Error fetching states:", error);
                                                                    setStates([]);
                                                                }
                                                            } else {
                                                                setStates([]);
                                                            }
                                                        }}
                                                        onBlur={() => validation.setFieldTouched("country", true)}
                                                        className={validation.touched.country && validation.errors.country ? "is-invalid" : ""}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                backgroundColor: "#f3f3f4",
                                                                border: "none"
                                                            })
                                                        }}
                                                    />
                                                    {validation.touched.country && validation.errors.country && (
                                                        <div className="invalid-feedback">{validation.errors.country}</div>
                                                    )}
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="state">State</Label>
                                                    <Select
                                                        inputId="state"
                                                        name="state"
                                                        options={Array.isArray(states)
                                                            ? states.map(state => ({
                                                                value: state.STATE_ID,
                                                                label: state.STATENAME
                                                            }))
                                                            : []}
                                                        isSearchable
                                                        isClearable
                                                        placeholder="Select State"
                                                        value={
                                                            states.find(r => r.STATE_ID === validation.values.state)
                                                                ? {
                                                                    value: validation.values.state,
                                                                    label: states.find(r => r.STATE_ID === validation.values.state).STATENAME
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            validation.setFieldValue("state", selectedOption ? selectedOption.value : "");
                                                        }}
                                                        onBlur={() => validation.setFieldTouched("state", true)}
                                                        className={validation.touched.state && validation.errors.state ? "is-invalid" : ""}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                backgroundColor: "#f3f3f4",
                                                                border: "none"
                                                            })
                                                        }}
                                                    />
                                                    {validation.touched.state && validation.errors.state && (
                                                        <div className="invalid-feedback d-block">{validation.errors.state}</div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* City / Zip */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="city">City</Label>
                                                    <Input
                                                        id="city"
                                                        name="city"
                                                        type="text"
                                                        placeholder="Enter City"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.city}
                                                        invalid={validation.touched.city && !!validation.errors.city}
                                                    />
                                                    <FormFeedback>{validation.errors.city}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="zipCode">Zip Code</Label>
                                                    <Input
                                                        id="zipCode"
                                                        name="zipCode"
                                                        type="text"
                                                        placeholder="Enter Zip Code"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.zipCode}
                                                        invalid={validation.touched.zipCode && !!validation.errors.zipCode}
                                                    />
                                                    <FormFeedback>{validation.errors.zipCode}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>



                                        {/* Submit */}
                                        <div className="d-grid mt-4">
                                            <Button
                                                type="submit"
                                                color="primary"
                                                className="px-5 py-2 fw-semibold rounded-3"
                                                disabled={validation.isSubmitting}
                                            >
                                                {validation.isSubmitting ? "Updating..." : "Save Changes"}
                                            </Button>
                                        </div>
                                        <div className="text-center mt-3">
                                            <Link to="/change-password" className="text-primary fw-semibold">
                                                Change Password
                                            </Link>
                                        </div>

                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </div>
    );
};

export default withRouter(UserProfile);
